import { Component, OnInit } from '@angular/core';

import { SidePanelBase } from '../../../common/components/side-panel-base.class';
import { State } from '../../../flow/models/flow.model';
import { FlowTemplate } from '../../../common/models/flow.dto';
import { SidePanelService } from '../../../common/services/side-panel.service';
import { areEqual } from '../../models/editor.model';

@Component({
    selector: 'app-workflow-diagram-end-editor',
    templateUrl: './workflow-diagram-end-editor.component.html',
    standalone: false
})
export class WorkflowDiagramEndEditorComponent extends SidePanelBase implements OnInit {

  static componentName = "WorkflowDiagramEndEditorComponent";


  activeTemplate: FlowTemplate;
  preEditStateName: string;
  selectedState: State;
  showDuplicateNameWarning: boolean = false;

  constructor(public sidePanel: SidePanelService) {
    super();
  }

  ngOnInit() {
    this.activeTemplate = this.componentData.template;
    this.selectedState = this.componentData.selectedState;
    this.preEditStateName = this.selectedState.name;
  }

  cancel(): void {
    this.selectedState.name = this.preEditStateName;
    this.selectedStateNameChanged(this.selectedState.name);
    this.showDuplicateNameWarning = false;
    this.sidePanel.toggleSidePanel(false);
  }

  duplicateStateName(newStateName: string): boolean {
    for (let s = 1; s < this.activeTemplate.states.length; s++) {
      let st = this.activeTemplate.states[s];
      if (!areEqual(st, this.selectedState) && st.name == newStateName) {
        return true;
      }
    }
    return false;
  }

  selectedStateNameChanged(e: any) {
    let isDuplicate = this.duplicateStateName(e);
    if (!isDuplicate) {
      this.showDuplicateNameWarning = false;
      this.saveMethod.emit({ method: "changeEvent", data: this.selectedState });
    } else {
      this.showDuplicateNameWarning = true;
    }
  }

}
